
export default {
  name: 'OnboardingCommentIcon',
};
